import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import addUserIcon from "../../assets/addUserIcon.svg"
import CardSeguimiento from "./CardSeguimiento.jsx";
import DetailContact from './DetailContact';
import { useWindowWidth } from "@react-hook/window-size";
import AgregarContacto from "./AgregarContacto.jsx"
import Swal from "sweetalert2";
import { getAllsClientes, updateContactById, getClienteById } from "../../../../endpoints"
import test from "../../assets/Animacion-nosotros.webm"
import { useLocation, useParams } from "react-router-dom";
import CrearCliente from "./CrearCliente.jsx"
import CustomCircularProgress from "../../../../Components/Loading/CustomCircularProgress.jsx"
import { 
  VideoCont, 
  DivBoxContainer, 
  DivContentFilters, 
  DivFlexColumn, 
  ActionBtn, 
  Input, 
  ContainerBox, 
  DivRow, 
  DivColumn1, 
  DivRow1, 
  ScrollContainer, 
  Text, 
  Text1 
} from './StyledComponents'; 

const Clientes = ({ user }) => {
  const [contacts, setContacts] = useState([]);
  const [contactsFilter, setContactsFilter] = useState([]);
  const [seActualizoContacto, setSeActualizoContacto] = useState(false);
  const params = useParams();
  const onlyWidth = useWindowWidth();

  const navigate = useNavigate()
  const [openModalObservaciones, setOpenModalObservaciones] = useState(false);
  const [openCreateNuevoCliente, setOpenCreateNuevoCliente] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [buscador, setBuscador] = useState();
  const scrollContainerRef = useRef(null);
  const [openAddContact, setOpenAddContact] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openModalAddSeguimiento, setOpenModalAddSeguimiento] = useState(false);


  const [selectedContact, setSelectContact] = useState();
  const [totalcontactViewer, setTotalcontactViewer] = useState();
  const [formData, setFormData] = useState({
    nombre: '',
    apellido: '',
    telefono: '',
    email: '',
    ramo: '',
    asesorAsignado: '',
  });
  const openCreateNuevoCliente2 = () => {
    setOpenCreateNuevoCliente(true)
  }
  const closeCreateNuevoCliente = () => {
    setOpenCreateNuevoCliente(false)
  }

  useEffect(() => {
    console.log(selectedContact, "selectedContact")
  }, [selectedContact]);

  const getContactID = async () => {
    getClienteById(params.id).then((response) => {
      if (response.status === 200) {
        console.log(response.data)
        setSelectContact(response.data)
        // Adding a delay of 2 seconds
        setTimeout(() => {
          setLoading(false);
        }, 500);
      } else {
        console.log(response)
        setLoading(false)

      }
    })
  }

  useEffect(() => {
    if (params.id) {
      console.log(params.id, "HOLA")
      setLoading(true)
      getContactID()
    }
    console.log(params.id, "HOLA")
  }, [params]);

  console.log(params)




  const handleNextPage = (currentPage) => {
    if (currentPage <= totalPages) {
      console.log("soy menor")
      let auxCurrent = currentPage + 1;
      console.log(currentPage, "currentPage")
      console.log(auxCurrent, "auxCurrent")
      setCurrentPage(auxCurrent);
    } else {
      console.log("soy mayor")
    }
  };

  const getContacts = async (buscador) => {
    setLoading2(true);
    console.log(user.id)
    getAllsClientes({
      page: currentPage,
      perPage: buscador ? null : 30,
      filterBy: buscador,
      userId: user.id,
      userType: user.type
    }).then((response) => {
      if (response?.status === 200) {

        if (buscador) {

          let newContacts
          if (seActualizoContacto) {
            newContacts = response.data.clientes;
          } else {
            newContacts = [...contacts, ...response.data.clientes];
          }
          console.log(response.data, "A")
          setContactsFilter(response.data.clientes)
          // console.log(response)
          setTotalcontactViewer(response.data.total)
          setTotalPages(Math.ceil(response.data.total)); // Suponiendo que tienes la información del total de contactos
          // setLoading(false);
          setLoading2(false)
        }
        else {
          let newContacts
          if (seActualizoContacto) {
            newContacts = response.data.clientes;
          } else {
            newContacts = [...contacts, ...response.data.clientes];
          }

          console.log(response.data.clientes)
          setContacts(newContacts);

          setTotalcontactViewer(response.data.total)
          console.log(Math.ceil(response.data.total / 30))
          setTotalPages(Math.ceil(response.data.total / 30)); // Suponiendo que tienes la información del total de contactos
          setLoading2(false)
        }

      } else {
        console.log(response);
        setLoading2(false)
      }
    });
  };

  useEffect(() => {
    console.log(currentPage, "CONSOLE LOG CURRENT PAGE")
    setLoading2(true)
    getContacts(buscador)
  }, [currentPage, buscador]);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    const handleScroll = () => {
      if (scrollContainer.scrollHeight - scrollContainer.scrollTop === scrollContainer.clientHeight) {
        console.log("siguiente pagina")
        console.log(currentPage, "Dentro del scroll")
        handleNextPage(currentPage);
      }
    };
    scrollContainer.addEventListener('scroll', handleScroll);
    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, [currentPage, buscador, scrollContainerRef.current]);



  const handlerOpenModal = () => {
    setOpenModal(true);
  }
  const handlerOpenModalSeguimiento = () => {
    setOpenModalAddSeguimiento(true);
  }
  const handlerOpenModalObservaciones = () => {
    setOpenModalObservaciones(true);
  }
  const closeModalObservaciones = () => {
    setOpenModalObservaciones(false);
  }
  const closeModal = () => {
    setOpenModal(false);
  }
  const closeModalAddSeguimiento = () => {
    setOpenModalAddSeguimiento(false);
  }

  const navigateAddContactBtn = () => {
    if (onlyWidth > 800) {
      setOpenAddContact(true);

    } else {
      navigate('/add-contacts');
    }
  }

  const navigateDeleteContactBtn = () => {
    if (selectedContact?.id) {
      Swal.fire({
        title: "¿Está seguro que desea eliminar este contacto?",
        text: "Tenga en cuenta que ya no podrá acceder a toda la informacion asociada a este contacto.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#003049",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          // dispatch(deleteUser(userInfo))
          //   .then((response) => {
          //     if (response.status === 200) {
          //       navigate(PublicRoute.home);
          //       localStorage.removeItem("user");
          //       localStorage.removeItem("Session");
          //       localStorage.removeItem("userType");
          //     }
          //   })
          //   .catch((error) => {
          //     Swal.fire(
          //       "Se produjo un error",
          //       "Por alguna razón no se pudo completar la acción. Vuelva a intentarlo",
          //       "error"
          //     );
          //   });
          Swal.fire({
            icon: "success",
            title: "El contacto fue eliminado",
            confirmButtonText: "Listo",
            confirmButtonColor: "#003049",
          });
          console.log("SE ELIMINO EL CONTACTO")
        }
      });
    }

  }

  const [errors, setErrors] = useState({
    photo: '',
    name: '',
    lastname: '',
    phone: '',
    email: '',
    password: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    setFormData({
      ...formData,
      photo: file,
    });
  };
  const handleChangeBuscador = (e) => {
    const { name, value } = e.target;
    console.log(value)
    console.log(scrollContainerRef, "ASD")
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0;
    }
    setBuscador(value);

  };
  const handleFormClick = (e) => {
    e.stopPropagation(); // Evita que el evento de clic se propague hacia arriba
  };
  return (

    <ContainerBox >
      <DivContentFilters params={params}>
        <DivRow>
          <DivColumn1>
      
            <Text1>{`Total: ${totalcontactViewer ? totalcontactViewer : 0}`}</Text1>
          </DivColumn1>
          <DivRow1>
            <ActionBtn
              src={addUserIcon}
              onClick={openCreateNuevoCliente2}
            />

          </DivRow1>

        </DivRow>
        <Input
          type="text"
          placeholder="Buscar..."
          value={buscador}
          onChange={handleChangeBuscador}
        />
        {/* <button onClick={handlePrevPage} disabled={currentPage === 1}>Página anterior</button>
        <button onClick={handleNextPage} disabled={currentPage === totalPages}>Página siguiente</button> */}
        <ScrollContainer ref={scrollContainerRef} >
          {contacts && contacts.length > 0 && !buscador ?
            (
              <>
                {contacts.map((contact, index) => (
                  <CardSeguimiento
                    key={index}
                    contact={contact}
                    handlerOpenModalObservaciones={handlerOpenModalObservaciones}
                    handlerOpenModal={handlerOpenModal}
                    formData={formData}
                    setFormData={setFormData}
                    setSelectContact={setSelectContact}
                    selectedContact={selectedContact}

                  />
                ))}
              </>
            ) : (
              <>
                {!buscador ?

                  <Text style={{ textAlign: 'center' }}>No se encontraron resultados.</Text> : null
                }
              </>



            )
          }
          {buscador && contactsFilter && contactsFilter.length > 0 ?
            (
              <>
                {contactsFilter.map((contact, index) => (
                  <CardSeguimiento
                    key={index}
                    contact={contact}
                    handlerOpenModalObservaciones={handlerOpenModalObservaciones}
                    handlerOpenModal={handlerOpenModal}
                    formData={formData}
                    setFormData={setFormData}
                    setSelectContact={setSelectContact}
                    selectedContact={selectedContact}

                  />
                ))}
              </>
            ) : (
              <>
                {buscador ?

                  <Text style={{ textAlign: 'center' }}>No se encontraron resultados.</Text> : null
                }
              </>
            )
          }
        </ScrollContainer>
      </DivContentFilters>
      <DivFlexColumn params={params} >
        {
          openCreateNuevoCliente ?
            <CrearCliente
              user={user}
              stopPropagation={handleFormClick}
              closeCreateNuevoCliente={closeCreateNuevoCliente}
              getClientes={getContacts}
              setClientes={setContacts}
              setSeActualizoContacto={setSeActualizoContacto}
            />
            : null
        }
        {
          openAddContact ?
            <AgregarContacto
              openAddContact={openAddContact}
              setOpenAddContact={setOpenAddContact}
            />
            : null
        }
        {
          loading === false && selectedContact?.id !== undefined ? (
            <DetailContact
              selectedContact={selectedContact}
              formData={formData}
              handlerOpenModal={handlerOpenModal}
              handlerOpenModalObservaciones={handlerOpenModalObservaciones}
              openModalObservaciones={openModalObservaciones}
              openModal={openModal}
              handlerOpenModalSeguimiento={handlerOpenModalSeguimiento}
              closeModalObservaciones={closeModalObservaciones}
              closeModal={closeModal}
              setSeActualizoContacto={setSeActualizoContacto}
              getContacts={getContacts}
              getContactID={getContactID}
              scrollContainerRef={scrollContainerRef}
              setContacts={setContacts}
              closeModalAddSeguimiento={closeModalAddSeguimiento}
              openModalAddSeguimiento={openModalAddSeguimiento}
              user={user}
            />
          ) : loading === false && !selectedContact?.id ? (
            <DivBoxContainer>
              <VideoCont muted autoPlay loop src={test} />
            </DivBoxContainer>
          ) : (
            <CustomCircularProgress size={50} padding='15vw' />
          )
        }


      </DivFlexColumn>
    </ContainerBox>

  );
};






export default Clientes;